module.exports = __webpack_public_path__ + "static/media/BHARATHIYAR UNIVERSITY APPLICATION.ea01723b.pdf";